class StickyBuyButton {
  constructor() {
    this.QUANTITY_INPUT = ".js-counter-quantity";
    this.STICKY_BAR = "sticky-buy-button";
    this.STICKY_SUBMIT_BUTTON = ".wt-product__sticky-buy__button";
    this.MAIN_SUBMIT_BUTTON = '[name="add"]';
    this.PRODUCT_FORM = "form[id^='product-form-']";
  }

  getQuantityInput(container) {
    if (null == container) {
      return null;
    }
    return container.querySelector(this.QUANTITY_INPUT);
  }

  getProductForm(stickyBar) {
    const stickySubmitButton = stickyBar.querySelector(this.STICKY_SUBMIT_BUTTON);
    if (null == stickySubmitButton) {
      return null;
    }
    return document.getElementById(stickySubmitButton.getAttribute("form"));
  }

  getStickyBar(productForm) {
    const stickyBars = document.querySelectorAll(this.STICKY_BAR);
    for (const stickyBar of stickyBars) {
      if (productForm === this.getProductForm(stickyBar)) {
        return stickyBar;
      }
    }
    return null;
  }

  copyQuantity(fromInput, toInput) {
    if (null == fromInput || null == toInput) {
      return;
    }
    if (toInput.value === fromInput.value) {
      return;
    }
    toInput.value = fromInput.value;
  }

  getPartnerQuantityInput(quantityInput) {
    const stickyBar = quantityInput.closest(this.STICKY_BAR);
    if (null != stickyBar) {
      return this.getQuantityInput(this.getProductForm(stickyBar));
    }
    const productForm = quantityInput.closest(this.PRODUCT_FORM);
    if (null == productForm) {
      return null;
    }
    return this.getQuantityInput(this.getStickyBar(productForm));
  }

  onQuantityChange = (event) => {
    const changedInput = event.target;
    if (!changedInput.matches?.(this.QUANTITY_INPUT)) {
      return;
    }
    this.copyQuantity(changedInput, this.getPartnerQuantityInput(changedInput));
  };

  onStickySubmitClick = (event) => {
    const stickySubmitButton = event.target.closest?.(this.STICKY_SUBMIT_BUTTON);
    if (null == stickySubmitButton) {
      return;
    }
    const stickyBar = stickySubmitButton.closest(this.STICKY_BAR);
    if (null == stickyBar) {
      return;
    }
    const productForm = this.getProductForm(stickyBar);
    if (null == productForm) {
      return;
    }
    const mainSubmitButton = productForm.querySelector(this.MAIN_SUBMIT_BUTTON);
    if (null == mainSubmitButton || mainSubmitButton.disabled) {
      return;
    }
    this.copyQuantity(this.getQuantityInput(stickyBar), this.getQuantityInput(productForm));
    mainSubmitButton.click();
  };

  init() {
    document.addEventListener("change", this.onQuantityChange);
    document.addEventListener("click", this.onStickySubmitClick);
  }
}

if ("loading" == document.readyState) {
  document.addEventListener("DOMContentLoaded", () => {
    new StickyBuyButton().init();
  });
} else {
  new StickyBuyButton().init();
}
